import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URI + '/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

// Public endpoints
export const subscribeToNewsletter = async (email) => {
  const response = await axios.post(`${API_URL}/newsletter/subscribe`, { email });
  return response.data;
};

// Admin endpoints
export const checkSubscription = async (email) => {
  try {
    const response = await axios.get(`${API_URL}/newsletter/check/${email}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error checking subscription:', error);
    throw error;
  }
};

export const getAllSubscribers = async (params) => {
  try {
    const response = await axios.get(`${API_URL}/newsletter/subscribers`, {
      ...getAuthHeaders(),
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching subscribers:', error);
    throw error;
  }
};

export const removeSubscriber = async (email) => {
  try {
    const response = await axios.delete(
      `${API_URL}/newsletter/unsubscribe/${email}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error removing subscriber:', error);
    throw error;
  }
};

// Get all subscribers (admin)
export const getSubscribers = async (filters = {}) => {
  try {
    const queryString = new URLSearchParams(filters).toString();
    const response = await axios.get(
      `${API_URL}/newsletter${queryString ? `?${queryString}` : ''}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching subscribers:', error);
    throw error;
  }
};

// Update subscriber (admin)
export const updateSubscriber = async (id, data) => {
  try {
    const response = await axios.put(
      `${API_URL}/newsletter/${id}`,
      data,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error updating subscriber:', error);
    throw error;
  }
};

// Add note to subscriber (admin)
export const addNote = async (id, content) => {
  try {
    const response = await axios.post(
      `${API_URL}/newsletter/${id}/notes`,
      { content },
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error adding note:', error);
    throw error;
  }
};

// Delete subscriber (admin)
export const deleteSubscriber = async (id) => {
  try {
    const response = await axios.delete(
      `${API_URL}/newsletter/${id}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting subscriber:', error);
    throw error;
  }
};

// Bulk import subscribers (admin)
export const bulkImportSubscribers = async (subscribers) => {
  try {
    const response = await axios.post(
      `${API_URL}/newsletter/bulk-import`,
      { subscribers },
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error importing subscribers:', error);
    throw error;
  }
}; 